import RecentlyViewedGoods from './pages/RecentlyViewedGoods/RecentlyViewedGoods.page';
import type { ScreenItem } from 'shared/src/types';
import { GoodsDetailPage } from './pages/GoodsDetail';
import { GoodsListPage } from './pages/GoodsList';
import { GoodsReviewSnoScreen } from './pages/GoodsReviewSno';
import { GoodsReviewListScreen } from './pages/GoodsReviewList';
import { resolveGoodsListType } from './pages/GoodsList/utils/resolveGoodsListType';
import { isWeb } from 'shared/src/utils';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

export const GoodsScreens: ScreenItem[] = [
  {
    name: 'RecentlyViewedGoods',
    component: RecentlyViewedGoods,
    path: WEB_ROUTE_PATHS.RecentlyViewedGoods,
    options: {
      title: '최근 본 상품 - 에이블리 스토어',
    },
  },
  {
    name: 'GoodsList',
    component: GoodsListPage,
    path: WEB_ROUTE_PATHS.GoodsList,
    options: {
      title: '상품 목록 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : (props.extras ?? {});

      return {
        type: resolveGoodsListType(extras.type),
        goodsSno:
          typeof extras.goods_sno === 'string'
            ? Number(extras.goods_sno)
            : extras.goods_sno,
        landingFrom: extras.landing_from,
        position: extras.position,
      };
    },
  },
  {
    name: 'GoodsDetail',
    component: GoodsDetailPage,
    path: WEB_ROUTE_PATHS.GoodsDetail,
    options: {
      title: '상품 상세 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : (props.extras ?? {});

      if (isWeb) {
        return {
          extras,
        };
      }

      return {
        goodsId:
          extras.sno ??
          extras.TARGET?.goods_sno ??
          extras.TARGET?.b ??
          extras.TARGET?.b?.goods_sno ??
          extras.TARGET?.c?.goods_sno,
        extras,
      };
    },
  },
  // 내용은 웹뷰지만 주소(`/reviews/:goodsSno`)를 유지해야 해서 전용 화면으로 둔다.
  {
    name: 'GoodsReviewSno',
    component: GoodsReviewSnoScreen,
    path: WEB_ROUTE_PATHS.GoodsReviewSno,
    options: {
      title: '리뷰 - 에이블리 스토어',
    },
  },
  {
    name: 'GoodsReviewList',
    component: GoodsReviewListScreen,
    path: WEB_ROUTE_PATHS.GoodsReviewList,
    options: {
      title: '리뷰 - 에이블리 스토어',
    },
  },
];
